import React, { useState } from 'react';
import { Phone, ShieldCheck, Star, CheckCircle2 } from 'lucide-react';
import { ShowerQuoteForm } from '../../components/ShowerQuoteForm/ShowerQuoteForm';
export function HeroQuotePanel() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <div className="lg:col-span-5 xl:col-span-5 xl:col-start-8 anim-fade-scale" style={{
    animationDelay: '0.2s'
  }} id="quote-form" data-id="element-1581">
      <div className="bg-white rounded-2xl shadow-soft border border-gray-100 p-5 md:p-6 relative overflow-hidden" data-id="element-1582">
        <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-1583"></div>

        {!isSubmitted ? <>
            <div className="inline-block bg-glass text-primary text-[10px] font-bold uppercase tracking-wider py-1 px-2.5 rounded mb-3" data-id="element-1584">
              Free In-Home Quote
            </div>
            <h3 className="text-xl lg:text-2xl font-bold text-navy-900 mb-1.5 tracking-tight" data-id="element-1585">
              Request a Shower Glass Quote
            </h3>
            <p className="text-xs lg:text-sm text-gray-600 mb-4 leading-relaxed" data-id="element-1586">
              Submit your details and a Kosin's Glass team member will contact
              you to confirm your bathroom layout, photos, rough measurements,
              remodel stage, glass style and hardware preferences.
            </p>

            <ShowerQuoteForm onSubmit={handleSubmit} data-id="element-1587" />

            <div className="mt-4 text-center" data-id="element-1588">
              <a href="tel:5175457772" className="inline-flex items-center gap-1.5 text-xs lg:text-sm font-medium text-navy-900 hover:text-primary transition-colors" data-id="element-1589">
                <Phone className="w-3.5 h-3.5" data-id="element-1590" />
                Prefer to call? Howell Main Service Center: 517-545-7772
              </a>
            </div>

            <div className="mt-3 text-center border-t border-gray-100 pt-3" data-id="element-1591">
              <p className="text-[10px] text-gray-400 flex items-center justify-center gap-1" data-id="element-1592">
                <ShieldCheck className="w-3 h-3" data-id="element-1593" />
                We respect your privacy. Your details are safe with us.
              </p>
            </div>

            {/* Micro testimonial */}
            <figure className="mt-3 bg-gray-50 rounded-xl p-3 border border-gray-100" data-id="element-1594">
              <div className="flex items-center gap-1 mb-1.5" aria-label="5-star review" data-id="element-1595">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-1596" />)}
              </div>
              <blockquote className="text-xs text-gray-600 italic leading-relaxed" data-id="element-1597">
                “[Paste real customer review here.]”
              </blockquote>
              <figcaption className="text-[10px] text-gray-500 mt-1.5 not-italic" data-id="element-1598">
                — [Customer Name], [City] · Shower Glass Customer
              </figcaption>
            </figure>
          </> : <div className="py-12 text-center anim-fade-scale" data-id="element-1599">
            <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-1600">
              <CheckCircle2 className="w-8 h-8" data-id="element-1601" />
            </div>
            <h3 className="text-2xl font-bold text-navy-900 mb-3" data-id="element-1602">
              Quote Request Received!
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-1603">
              Thank you. A Kosin's Glass team member will contact you shortly to
              confirm your bathroom details and schedule your free estimate.
            </p>
            <div className="bg-gray-50 p-4 rounded-xl text-sm text-gray-700" data-id="element-1604">
              <p className="font-medium mb-2" data-id="element-1605">Need immediate assistance?</p>
              <a href="tel:5175457772" className="text-primary font-bold hover:underline flex items-center justify-center gap-2" data-id="element-1606">
                <Phone className="w-4 h-4" data-id="element-1607" /> Call 517-545-7772
              </a>
            </div>
          </div>}
      </div>
    </div>;
}